export default __webpack_public_path__ + "static/media/create event.910c6caf.png";